module.exports = __webpack_public_path__ + "img/数据.d4c51d4c.svg";